import { CatInlineNotification } from '@blocks-react/components/InlineNotification';
import { CatIconSuccess } from '@blocks-react/components/Icons/Success';
import { CatIconWarningTriangle } from '@blocks-react/components/Icons/WarningTriangle';
import { CatIconWarningCircle } from '@blocks-react/components/Icons/WarningCircle';
import { CAT_BANNER_ICON_TYPES } from './constants';
import { MessageBannerProps } from './types';

export const MessageBanner = ({
  heading,
  variant,
  children,
}: MessageBannerProps) => {
  const { SUCCESS, WARNING, ERROR } = CAT_BANNER_ICON_TYPES;
  return (
    <div className={'pt-3'}>
      <CatInlineNotification
        heading={heading}
        variant={variant}
        data-testid="cat-banner"
      >
        {variant === ERROR && (
          <CatIconWarningCircle slot="before" data-testid="error-icon" />
        )}
        {variant === SUCCESS && (
          <CatIconSuccess slot="before" data-testid="success-icon" />
        )}
        {variant === WARNING && (
          <CatIconWarningTriangle slot="before" data-testid="warning-icon" />
        )}
        {children}
      </CatInlineNotification>
    </div>
  );
};
